import { Button, Col, Form, message, Row, Select, Upload } from "antd";
import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import transmissionService from "@services/transmission.service";

const { Option } = Select;
const { Dragger } = Upload;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

const Import = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();

  const handleFormValuesChange = async (changedValues) => {
    // const formFieldName = Object.keys(changedValues)[0];
  };

  const customRequest = async ({ file, onSuccess, onError, ...info }) => {
    try {
      setTimeout(() => {
        onSuccess(info);
      }, 1000);
    } catch (error) {
      onError(error);
    }
  };

  const onChange = async (info) => {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      // toast.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      toast.error(`${info.file.name} file upload failed.`);
    }
  };

  const onDrop = (e) => {
    console.log("Dropped files", e.dataTransfer.files);
  };

  const onFinish = async ({
    file: {
      file: { originFileObj },
    },
    ...values
  }) => {
    setSubmitted(true);
    try {
      const formData = new FormData();

      formData.append("file", originFileObj);
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });

      const res = await transmissionService.upload(formData);

      console.log(res);
      // setFileLink(res.data);
    } catch (err) {

      setSubmitted(false);
      console.log(err);
    } finally {
      setSubmitted(false);
    }
  };

  return (
    <div className="p-5">
      <div className="bg-white rounded-md border border-gray-200 p-5">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          onValuesChange={handleFormValuesChange}
        >
          <Row gutter={[14, 0]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
              <Form.Item
                name="type"
                label="Type"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select>
                  <Option value="Microwave Export">Microwave Export (.csv)</Option>
                  <Option value="NE Export">NE Export (.xls)</Option>
                  <Option value="LTP">LTP  (.xls)</Option>
                  <Option value="HFN-IP-MVO">HFN-IP-MVO  (.xlsx)</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="file"
                label="File"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Dragger
                  multiple={false}
                  onChange={onChange}
                  onDrop={onDrop}
                  maxCount={1}
                  customRequest={customRequest}
                >
                  <div className="flex justify-center text-blue-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12 w-12"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                      />
                    </svg>
                  </div>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">
                    Support for a single or bulk upload. Strictly prohibit from
                    uploading company data or other band files
                  </p>
                </Dragger>
              </Form.Item>
            </Col>

            <Col flex="auto" className="flex justify-end items-end">
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={submitted}
                  className="mt-4"
                >
                  Upload
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default Import;
